import { type API, type StreamingCommand } from '../aiStreamingOrchestratorPluginType';

import { createAppendNodeToEndCommand } from './append';
import { createInsertNodeAfterCommand } from './insert-after';
import { createInsertNodeBeforeCommand } from './insert-before';
import { createRemoveNodeCommand } from './remove';
import { createReplaceNodeCommand } from './replace';
import { createSetAttrsCommand } from './set-attributes';
import { createWrapNodeCommand } from './wrap';

/**
 * Creates a mapping of streaming command types to their corresponding command factories.
 * @param api - The API object containing the editor's core functionality.
 * @returns A mapping of streaming command types to their corresponding command factories.
 */
export function createStreamingCommands(api: API) {
	return {
		replaceNode: createReplaceNodeCommand(api),
		insertNodeBefore: createInsertNodeBeforeCommand(api),
		insertNodeAfter: createInsertNodeAfterCommand(api),
		removeNode: createRemoveNodeCommand(api),
		appendNode: createAppendNodeToEndCommand(api),
		appendNodeToEnd: createAppendNodeToEndCommand(api),
		wrap: createWrapNodeCommand(api),
		wrapNode: createWrapNodeCommand(api),
		setAttrs: createSetAttrsCommand(api),
	} as Record<StreamingCommand['type'], (command: StreamingCommand) => boolean>;
}
